export const APP_ENTITY = {
  MODEL: "model",
  AGENCY: "agency",
  CLIENT: "client",
}
